import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class VisionStepMeasure extends BasicEntity {
chronoCode: string;
code: string;
mode: string;
visionCode: string;
visionStepCode: string;
}

